import { countries } from './countries';
import { states } from './states';

export const fields = {
  first_name: {
    label: 'First name',
    type: 'text',
    defaultValue: '',
    name: 'first_name',
    autocomplete: 'given-name',
  },
  last_name: {
    label: 'Last name',
    type: 'text',
    defaultValue: '',
    name: 'last_name',
    autocomplete: 'family-name',
  },
  email: {
    label: 'Email address',
    type: 'text',
    defaultValue: '',
    name: 'email',
    autocomplete: 'email',
  },
  business_phone: {
    label: 'Business phone',
    type: 'text',
    defaultValue: '',
    name: 'business_phone',
    autocomplete: 'tel',
  },
  mobile_phone: {
    label: 'Mobile phone',
    type: 'text',
    defaultValue: '',
    name: 'mobile_phone',
    autocomplete: 'tel',
  },
  password: {
    label: 'Password',
    type: 'password',
    defaultValue: '',
    name: 'password',
    autocomplete: 'new-password',
  },
  password_confirmation: {
    label: 'Confirm password',
    type: 'password',
    defaultValue: '',
    name: 'password_confirmation',
    autocomplete: 'new-password',
  },
  business_name: {
    label: 'Business name',
    type: 'text',
    defaultValue: '',
    name: 'business_name',
    autocomplete: 'organization',
  },
  tax_id_number: {
    label: 'Tax ID number',
    type: 'text',
    defaultValue: '',
    name: 'tax_id_number',
    autocomplete: '',
  },
  business_license: {
    label: 'Business license',
    type: 'text',
    defaultValue: '',
    name: 'business_license',
    autocomplete: '',
  },
  country: {
    label: 'Country',
    type: 'select',
    defaultValue: '',
    name: 'country',
    options: countries.map((c) => ({ label: c, value: c })),
    autocomplete: '',
  },
  state: {
    label: 'State',
    type: 'select',
    defaultValue: '',
    name: 'state',
    options: states.map((s) => ({ label: s[0], value: s[1] })),
    autocomplete: 'address-level1',
  },
  city: {
    label: 'City',
    type: 'text',
    defaultValue: '',
    name: 'city',
    autocomplete: 'address-level2',
  },
  street: {
    label: 'Street',
    type: 'text',
    defaultValue: '',
    name: 'street',
    autocomplete: 'street-address',
  },
  zip_code: {
    label: 'Zip code',
    type: 'text',
    defaultValue: '',
    name: 'zip_code',
    autocomplete: 'postal-code',
  },
} as const;

export const interests = ['jewelry', 'diamonds', 'watches', 'gemstones'] as const;

export const defaultValues = Object.keys(fields).reduce(
  (all, current) => {
    const key = current as keyof typeof fields;
    return {
      ...all,
      [key]: fields[key].defaultValue,
    };
  },
  {
    jewelry: false,
    diamonds: false,
    watches: false,
    gemstones: false,
  } as Record<string, string | boolean>,
);
